<template>
  <div id="index">
    <div class="banner">
      <swiper class="banner_list" :options="swiperOption" v-if="loop.length>1">
        <swiper-slide class="banner_item" v-for="(item, index) in loop" :key="index">
          <img :src="item" alt class="banner_img" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <header>
        <div class="header_logo"></div>
        <div class="header_right">
          <div class="admin" v-if="yun==true"></div>
          <div class="login" >登录煤矿大脑服务平台</div>
          <div class="dowload"><a href="https://obs-vit.obs.cn-north-1.myhuaweicloud.com/VITCloud5.01.zip">可视化调度客户端下载</a></div>          
        </div>
      </header>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 全栈AI -->
      <div class="container_features">
        <div class="container_features_header">
          <p>煤矿大脑云服务</p>
          <p class="gang">
            <span></span>
          </p>
          <p style="color:#a0a0a0;margin-top:20px;font-weight:500">MINEBRAIN CLOUD SERVICES</p>
        </div>
        <div class="container_features_container"  @mouseenter="on_swiper_enter" @mouseleave="on_swiper_leave">
          <swiper :options="swiperOption2" ref="mySwiper">
            <swiper-slide class="nengli" href="http://tanshui.coal-cloud.cn">
              <div class="nengli_tubiao">
                <img src="../../static/images/icon-ts.png" alt />
              </div>
              <p class="nengli_header">人工智能煤矿探放水管理服务</p>
              <p class="nengli_container">实现探水设计、计划、作业、验收整个探水作业过程的信息化管理，利用人工智能视频识别技术对探水打钻过程视频进行实时识别分析、存储，准确识别钻探深度。</p>
            </swiper-slide>
            <swiper-slide class="nengli"  href="https://yuqing.coal-cloud.cn/">
              <div class="nengli_tubiao">
                <img src="../../static/images/icon-yq.png" alt />
              </div>
              <p class="nengli_header">舆情监测服务</p>
              <p
                class="nengli_container"
              >实现网络舆情监测、预警和分析，客观呈现互联网上的热点舆情，便于政府或企业掌握新闻舆情动态，由被动防治化为主动解决问题，提升政府监管职能或煤炭企业品牌形象。</p>
            </swiper-slide>
            <swiper-slide class="nengli" href="https://azx.coal-cloud.cn/">
              <div class="nengli_tubiao" style="margin-left: 34%;">
                <img src="../../static/images/icon-azx.png" alt />
              </div>
              <p class="nengli_header">安责险信息管理服务</p>
              <p
                class="nengli_container"
              >平台给政府监管机构和保监会提供监管服务，给保险公司提供承保前、承保中、出险后等增值服务,给煤矿提供事故预防服务及风险诊断服务。</p>
            </swiper-slide>
            <swiper-slide class="nengli" href="https://smcs.coal-cloud.cn">
              <div class="nengli_tubiao">
                <img src="../../static/images/icon-zhjk.png" alt />
              </div>
              <p class="nengli_header">煤矿信息化综合监控服务</p>
              <p
                class="nengli_container"
              >主要实现了矿端安全监控子系统数据的实时采集、上传，将煤矿的环境监测、人员定位、工业视频、调度通信、应急广播等多系统数据融合，结合GIS功能实现了关联分析、应急联动等功能，保证了多系统间的互联互通。通过构建风险指数模型计算煤矿的安全风险指数，明确了不同的专业、系统、区域出现问题的频次、严重程度，辅助决策。</p>
            </swiper-slide> 
            <swiper-slide class="nengli">
              <div class="nengli_tubiao">
                <img src="../../static/images/icon-ksh.png" alt />
              </div>
              <p class="nengli_header">可视化调度通信服务</p>
              <p
                class="nengli_container"
              >系统结合统一通信优势，将语音、视频、数据、会议、即时消息等通信类型合为一体，有效解决企业内部沟通问题，并横向融合了多个煤矿企业业务系统，扩展了PC终端，手机、IP话机、调度电话等设备之间的异构通信；纵向延伸了互联网公有云、煤炭专网、煤矿调度通信网络等，实现了多业务、大范围、高纵深的一体化通信解决方案。</p>
            </swiper-slide>           
          </swiper>
          <div class="swiper-button-prev" slot="button-prev">
            <img src="../../static/images/features_jiantou_left.png" alt />
          </div>
          <div class="swiper-button-next" slot="button-next">
            <img src="../../static/images/features_jiantou_right.png" alt />
          </div>
        </div>
      </div>
      
      <div style="background:#3665fd;height:2px;width:100%"></div>
      <!-- 底部 -->
      <footer>
        <div class="footer_top">
          <div class="footer_table">
            <div class="footer_container">
              <div class="footer_header">产品特点</div>
              <div class="footer_text">
                <p style="margin-top:8px;">智能化风险监测</p>                
                <p>多层次管理闭环</p>
                <p>云边端协同一体化</p>
                <p>适应多种煤矿场景</p>
              </div>
            </div>
            <div class="footer_container">
              <div class="footer_header">云服务</div>
              <div class="footer_text">
                <p style="margin-top:8px;"><a target="_blank" href="http://tanshui.coal-cloud.cn">探放水管理服务</a></p>
                <p><a target="_blank" href="https://azx.coal-cloud.cn/">安责险管理服务</a></p>
                <p><a target="_blank" href="https://yuqing.coal-cloud.cn/">舆情监测服务</a></p>
                <p><a target="_blank" href="https://smcs.coal-cloud.cn">信息化综合监控服务</a></p>
                <p><a >可视化调度通信服务</a></p>
              </div>
            </div>
            <div class="footer_container">
              <div class="footer_header">关于我们</div>
              <div class="footer_text">
                <p style="margin-top:8px;"><a target="_blank" href="http://www.jylink.com/page/about-jylink.html">公司简介</a></p>
                <p><a target="_blank" href="http://www.jylink.com/page/internal-news.html">企业文化</a></p>
                <p><a target="_blank" href="http://www.jylink.com/page/investCenter.html">投资者关系</a></p>
              </div>
            </div>            
            <div class="footer_container">
              <div class="footer_header">联系我们</div>
              <div class="footer_text">
                <p>全国客户服务热线：<br/>
400-811-0088</p>
                <p style="margin-top:8px;">地址：</p>
                <p>中国- 山西- 太原<br/>
长治路103号<br/>
阳光国际商务中心A座7层</p>
              </div>
            </div>            
          </div>
          <!-- <div class="ma"> -->
          <div class="gongzhong">
            <img src="../../static/images/qrguanfang.jpg" alt />
          </div>
          <p class="gongzhong_text">精英数智公众号</p>
          <div class="gongzhong" style="margin-left:1.8%;">
            <img src="../../static/images/qryunwei.jpg" alt />
          </div>
          <p class="gongzhong_text">精英数智服务号</p>
          <!-- </div> -->
        </div>
        <div style="background:#3d3d3d;height:1px;width:100%"></div>
        <div
          class="footer_bottom"       
        >精英数智科技股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;Copyright © 2019-2020&nbsp;&nbsp;&nbsp;&nbsp;All rights reserved.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a target="_blank" href="http://beian.miit.gov.cn">ICP:晋ICP备17008306号-1</a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14019202000100" style="display:inline-block;text-decoration:none;"><img src="/static/images/gaba.png" style="float:left;"/>晋公网安备 14019202000100号</a>
</div>
      </footer>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import $ from "jquery";

var imglist = [
  "../../static/images/icon-ts_hover.png",
  "../../static/images/icon-yq_hover.png",
  "../../static/images/icon-azx_hover.png",
  "../../static/images/icon-zhjk_hover.png",
  "../../static/images/icon-ksh_hover.png",
];
var imglists = [
  "../../static/images/icon-ts.png",
  "../../static/images/icon-yq.png",
  "../../static/images/icon-azx.png",
  "../../static/images/icon-zhjk.png",
  "../../static/images/icon-ksh.png"
];
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    const that = this;
    return {
      yun: "",
      //定义一个变量,接收后台传过来的图片
      loop: [
        "../../static/images/banner1.jpg",
        "../../static/images/banner3.jpg",
        "../../static/images/banner4.jpg"
      ],
      swiperOption: {
        // 所有配置均为可选（同Swiper配置）
        pagination: {
          el: ".swiper-pagination"
        },
        // direction: "vertical",
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        scrollbar: ".swiper-scrollbar",
        mousewheelControl: true,
        observeParents: true,
        // onTransitionStart(swiper){
        //   console.log(swiper)
        // }
        slidesPerView: 1, //页面显示几张图
        spaceBetween: 0, //左右间隔
        // slidesPerGroup: 3,
        // grabCursor: true,//鼠标光标
        autoplay: {
          delay: 3000, //秒
          stopOnLastSlide: false,
          disableOnInteraction: false //滑动不会失效
        },
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption2: {
        // 所有配置均为可选（同Swiper配置）
        pagination: {
          el: ".swiper-pagination"
        },
        // direction: "vertical",
        paginationClickable: true,
        // prevButton: ".swiper-button-prev",
        // nextButton: ".swiper-button-next",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        scrollbar: ".swiper-scrollbar",
        mousewheelControl: true,
        observeParents: true,
        // roundLengths : true,
        // onTransitionStart(swiper){
        //   console.log(swiper)
        // }
        slidesPerView: 4, //页面显示几张图
        spaceBetween: 0, //左右间隔
        // slidesPerGroup: 3,
        // grabCursor: true,//鼠标光标
        autoplay: {
          delay: 3000, //秒
          stopOnLastSlide: false,
          disableOnInteraction: false //滑动不会失效
        },
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // on: {
        //   slideChangeTransitionStart: function() {
        //     that.index = this.realIndex + 1; //获取轮播图片下标索引；这里有一个坑，之前网上找到的是用activeIndex，但后来网上说的是这个realIndex，原来activeIndex是swiper2.0的；而realIndex是swiper3.0的，（使用realIndex才实现了下标索引）
        //   }
        // }
      },
      swiperOption3: {
        // 所有配置均为可选（同Swiper配置）
        pagination: {
          el: ".swiper-pagination"
        },
        // direction: "vertical",
        paginationClickable: true,
        // prevButton: ".swiper-button-prev",
        // nextButton: ".swiper-button-next",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        scrollbar: ".swiper-scrollbar",
        mousewheelControl: true,
        observeParents: true,
        // onTransitionStart(swiper){
        //   console.log(swiper)
        // }
        slidesPerView: 3, //页面显示几张图
        spaceBetween: 0, //左右间隔
        // slidesPerGroup: 3,
        // grabCursor: true,//鼠标光标
        // roundLengths : true,//移动时让字体不会发生模糊
        autoplay: {
          delay: 3000, //秒
          stopOnLastSlide: false,
          disableOnInteraction: false //滑动不会失效
        },
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // on: {
        //   slideChangeTransitionStart: function() {
        //     that.index = this.realIndex + 1; //获取轮播图片下标索引；这里有一个坑，之前网上找到的是用activeIndex，但后来网上说的是这个realIndex，原来activeIndex是swiper2.0的；而realIndex是swiper3.0的，（使用realIndex才实现了下标索引）
        //   }
        // }
      }
    };
  },
  methods: {
    Register() {
      this.$router.push("/register");
    },
    Login() {
      this.$router.push("/login");
    },
    on_swiper_enter(){      
      this.$refs.mySwiper.swiper.autoplay.stop();      
    },
    on_swiper_leave(){
      this.$refs.mySwiper.swiper.autoplay.start();
    },
  },
  mounted() {

    $(".nengli")
      .mouseover(function() {
        $(".nengli").each(function(i) {
          $(this).removeClass("hover");
        });
        $(this).addClass("hover");
        $(this)
          .find(".nengli_container")
          .css({ color: "white" });
        $(this)
            .find("img")
            .attr("src", imglist[($(".nengli").index(this)+1)%5]);
      })
      .mouseout(function() {
        $(this).addClass("hover");
        $(this)
          .find(".nengli_container")
          .css({ color: "#999999" });
          console.log($(".nengli").index(this));
          $(this)
            .find("img")
            .attr("src", imglists[($(".nengli").index(this)+1)%5]);
      });
      $(".nengli").click(function() {
        if($(this).attr("href"))
          window.open($(this).attr("href"));
        });
    $(".container_features_container").mouseout(function() {
      $(".nengli").removeClass("hover");
      $(this)
        .find(".nengli_container")
        .css({ color: "#999999" });
    });

    // 方案
    $(".solustion_container_content")
      .mouseover(function() {
        $(".solustion_container_content").each(function(i) {
          $(this).removeClass("hovers");
        });
        $(this).addClass("hovers");
        $(this)
          .find(".solution_text")
          .css({ color: "#6699ff" });
      })
      .mouseout(function() {
        $(this).addClass("hovers");
        $(this)
          .find(".solution_text")
          .css({ color: "#6699ff" });
      });
    $(".solustion_container_wrap").mouseout(function() {
      $(".solustion_container_content").removeClass("hovers");
      $(this)
        .find(".solution_text")
        .css({ color: "black" });
    });
  }
};
</script>
<style lang='less' scoped>
#index {
  width: 100%;
  margin: auto;
}
#index .banner {
  height: 759px;
  position: relative;
}
.swiper-container {
  width: 100%;
  height:100%;
}
#index .banner_img {
  width: 100%;
  height:100%;
  object-fit: cover;
}
#index header {
  width: 100%;
  height: 100px;
  border-bottom: 1px solid #999999;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
#index .header_logo {
  width: 146px;
  height: 47px;
  background: url("../../static/images/logo.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 28px;
  left: 18.8%;
}
#index .header_right {
  width: 29.8%;
  height: 16px;
  position: absolute;
  top: 44px;
  right: 19%;
  text-align:right;
}
#index .header_right div {
  float: right;
  font-size: 12px;
  line-height: 19px;
  cursor: pointer;
}
#index .header_right .admin {
  width: 13px;
  height: 14px;
  background: url("../../static/images/admin.png");
}
#index .header_right .register {
  color: white;
  margin-left: 13px;
}
#index .header_right .dowload {
  width: 150px;
  height: 15px;
  margin-left: 16px;
  color:#ffffff;  
  box-sizing: content-box;
}
#index .header_right .dowload a {
  color:#ffffff;
}
#index .header_right .login {
  margin-left: 16px;
  color: #21d7b8;
  box-sizing: content-box;
}
.container_features {
  width: 100%;
  height: 575px;
  background: #fbfbfb;
  position: relative;
}
.container_features_header {
  width: 403px;
  height: 92px;
  position: absolute;
  left: 50%;
  margin-left: -200px;
  top: 75px;
}
.container_features_header p {
  font-weight: 600;
  text-align: center;
}
.container_features_header .gang {
  width: 403px;
  height: 2px;
  background: #eae6e6;
  margin-top: 10px;
}
.container_features_header .gang span {
  display: block;
  width: 79px;
  height: 2px;
  background: #4679ff;
  margin-left: 162px;
}
.container_features_container {
  width: 63.9%;
  height: 309px;
  position: absolute;
  top: 218px;
  left: 15.9%;
  padding: 0px 3%;
}
.container_features_container .swiper-button-prev {
  width: 33px;
  height: 66px;
  background-image: none;
  left: 0px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  outline: none;
}
.container_features_container .swiper-button-next {
  width: 33px;
  height: 66px;
  background-image: none;
  right: 0px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  outline: none;
}
.nengli {
  width: 25% !important;
  height: 309px;
  float: left;
  cursor:pointer;
  // margin-left: 10px;
}
.nengli_tubiao {
  margin-top: 19.5%;
  margin-left: 36%;
}
.nengli_header {
  text-align: center;
  font-size: 18px;
  margin-top: 14px;
}
.nengli_container {
  margin-top: 16px;
  font-size: 13px;
  text-align: center;
  color: #999999;
  height: 96px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  padding: 0px 10px;
}
.hover {
  background: #3665fd;
  color: white;
}
.advantage {
  height: 699px;
  position: relative;
}
.advantage_container {
  width: 100%;
  height: 440px;
  background: url("../../static/images/youshibg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 0;
}
.advantage_img {
  width: 33.3%;
  height: 508px;
  position: absolute;
  left: 47.7%;
  top: -30px;
  z-index: 1;
}
.advantage_img img {
  width: 100%;
  height: 100%;
}
.advantage_text {
  width: 28.9%;
  height: 304px;
  margin-left: 18.8%;
  margin-top: 55px;
}
.advantage_text span {
  color: white;
}
.advantage_text p {
  height: 163px;
  font-size: 12px;
  color: #ffffff;
}
.solustion {
  position: relative;
  height: 826px;
  background: url("../../static/images/solutionbg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.solustion_container {
  width: 67.9%;
  height: 443px;
  position: absolute;
  bottom: 89px;
  left: 15.9%;
  padding: 0px 3%;
}
.solustion_container .swiper-button-prev {
  width: 33px;
  height: 66px;
  background-image: none;
  left: 0px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  outline: none;
}
.solustion_container .swiper-button-next {
  width: 33px;
  height: 66px;
  background-image: none;
  right: 12px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  outline: none;
}
.solustion_container_wrap {
  width: 100%;
  height: 443px;
  float: left;
}
.solustion_container .swiper-wrapper{
  margin-top: 15px;
}
.solustion_container_content {
  width: 30.3% !important;
  height: 424px;
  float: left;
  border: 2px solid transparent;
  margin-right: 2.7%;
  background: white;
  opacity: 0.8;
}
.solustion_img {
  width: 100%;
  height: 242px;
}
.solustion_img img {
  width: 100%;
  height: 100%;
}
.solution_text h3 {
  margin-top: 20px;
  font-size: 16px;
  padding-left: 10px;
  padding-right: 10px;
}
.solution_text p {
  font-size: 14px;
  margin-top: 10px;
  color: #666666;
  height: 108px;
  -webkit-line-clamp: 5;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  padding-right: 10px;
}
.hovers {
  border: 2px solid #3366ff;
  box-shadow: 0 0 8px #3366ff;
  transform:translate(0,-15px);
}
#index footer {
  height: 321px;
  background: #333333;
  color: #999999;
}
#index .footer_top {
  height: 247px;
  overflow: hidden;
}
#index .footer_table {
  width: 43.1%;
  height: 150px;
  margin-left: 18.8%;
  margin-top: 60px;
  float: left;
}
#index .footer_container {
  width: 24%;
  height: 145px;
  color: #cccccc;
  float: left;
}
#index .footer_container .footer_header {
  font-size: 17px;
  margin-bottom: 10px;
}
#index .footer_container .footer_text {
  font-size: 12px;
}
#index .footer_container .footer_text p {
  margin-top: 5px;
}
#index .ma {
  width: 19.2%;
  height: 134px;
  margin-top: 60px;
  float: left;
}
#index .gongzhong {
  width: 132px;
  height: 132px;
  float: left;
  margin-top: 60px;
}
#index .gongzhong img {
  width: 100%;
  height: 100%;
}
#index .gongzhong_text {
  width: 18px;
  font-size: 16px;
  line-height: 20px;
  margin-left: 0.9%;
  margin-top: 60px;
  float: left;
}
#index footer hr {
  color: #333333;
}
#index .footer_bottom {
  text-align: center;
  font-size: 15px;
  margin-top: 24px;
}
.footer_container a{
  color:#cccccc;
}
.footer_bottom a{
  color:#999999;
}

</style>


// WEBPACK FOOTER //
// src/components/index.vue